const { Progress } = require("antd");

const Component = ({ ...props }) => (
  <div className="progress--wrapper">
    <Progress {...props} />
  </div>
);

export default Component;
